import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { LockKey, ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) {
      setError(res.error || "Login mislykkedes");
      return;
    }
    nav("/admin");
  };

  return (
    <div
      data-testid="login-page"
      className="relative min-h-screen overflow-hidden bg-[#0A0A0A] text-white pitch-lines"
    >
      <a
        href="/"
        data-testid="login-back-home"
        className="mono-label absolute left-6 top-6 inline-flex items-center gap-2 text-neutral-400 hover:text-brand"
      >
        <ArrowLeft size={14} /> Tilbage til forsiden
      </a>

      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6">
        <div className="mb-6 grid h-12 w-12 place-items-center border border-brand bg-brand/10">
          <LockKey size={22} weight="bold" className="text-brand" />
        </div>
        <span className="section-eyebrow mb-3">Admin · Taastrup FC</span>
        <h1 className="font-heading text-5xl uppercase tracking-tight text-white">
          Log ind
        </h1>
        <p className="mt-3 text-center font-body text-neutral-400">
          Adgang til redigering af træning, nyheder, kampe og hold.
        </p>

        <form
          onSubmit={onSubmit}
          data-testid="login-form"
          className="mt-10 w-full hairline bg-neutral-950 p-6"
        >
          <label className="mono-label block text-neutral-400" htmlFor="email">
            E-mail
          </label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="login-email"
            className="mt-2 w-full border border-neutral-800 bg-black px-3 py-3 font-body text-white outline-none transition-colors focus:border-brand"
          />
          <label
            className="mono-label mt-5 block text-neutral-400"
            htmlFor="password"
          >
            Adgangskode
          </label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="login-password"
            className="mt-2 w-full border border-neutral-800 bg-black px-3 py-3 font-body text-white outline-none transition-colors focus:border-brand"
          />
          {error && (
            <p
              data-testid="login-error"
              className="mt-4 border border-red-900/50 bg-red-950/30 px-3 py-2 font-body text-sm text-red-300"
            >
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="btn-primary mt-6 w-full justify-center disabled:opacity-60"
          >
            {loading ? "Logger ind…" : "Log ind"}
          </button>
        </form>
      </div>
    </div>
  );
}
